// extracted by mini-css-extract-plugin
export default {"review-modal-mobile":"_ntt0vb","reviewModalMobile":"_ntt0vb"};